import { Controller, useFormContext } from 'react-hook-form';

import { ToggleButtonGroup as MuiToggleButtonGroup } from '@mui/lab';

export const ControlledToggleButtonGroup = ({ name, ...props }: any) => {
  const formContext = useFormContext();
  const value = formContext.watch(name);

  const handleChange = (_event: any, nextValue: any) => {
    formContext.setValue(name, nextValue, { shouldDirty: true });
  };

  return (
    <Controller
      name={name}
      // @ts-expect-error TS(2322): Type '{ name: any; onChange: (_event: any, nextVal... Remove this comment to see the full error message
      onChange={handleChange}
      render={() => (
        <MuiToggleButtonGroup
          value={value}
          onChange={handleChange}
          {...props}
        />
      )}
    />
  );
};
